<div class="promo-container">
  <div class="promo-form w-depth">
    <div class="form-title">{{'CLAIMPROMO.TITLE' | translate}}</div>
    <div class="form-text">{{'CLAIMPROMO.CLAIMTEXT' | translate}} {{name}}</div>
    <div class="form-input">
      <div class="error" *ngIf="codeError">{{'CLAIMPROMO.MISSING' | translate}}</div>
      <input *ngIf="!codeError" name="phone" [placeholder]="'CLAIMPROMO.PHONETXT' | translate" title="Phone Number"
             [textMask]="{mask: phoneMask}" (input)="phoneCheck(phone)" [(ngModel)]="phone">
    </div>
    <div class="form-btn">
      <button *ngIf="!codeError" (click)="claim(phone)" [disabled]="!validPhone"
              class="w-btn submit-btn" [innerHtml]="'CLAIMPROMO.CLAIMBTN' | translate" target="_blank">
      </button>
    </div>
    <div class="form-footer" [innerHTML]="'CLAIMPROMO.FOOTERTXT' | translate"></div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
  <div class="bottom-background"></div>
</div>
